import { Button } from '@/components/ui/button';
import { Download, Loader2 } from 'lucide-react';
import { useStructuredExportPDF } from '@/hooks/useStructuredExportPDF';
import { useToast } from '@/components/ui/use-toast';

interface ExportPDFButtonProps {
  filename?: string;
  buttonText?: string;
  variant?: 'default' | 'destructive' | 'outline' | 'secondary' | 'ghost' | 'link';
  size?: 'default' | 'sm' | 'lg' | 'icon';
  className?: string;
  // New props for structured export
  activeTab?: string;
  patientName?: string;
}

export const ExportPDFButton = ({
  filename = 'export',
  buttonText = 'Exporter PDF',
  variant = 'outline',
  size = 'default',
  className = '',
  activeTab = '',
  patientName = '',
}: ExportPDFButtonProps) => {
  const { exportZF, exportBilan, exportSeancesDashboard, isExporting: isExportingStructured } = useStructuredExportPDF();
  const { toast } = useToast();


  const handleExport = async () => {
    try {
        if (activeTab === 'reeducation') {
          await exportSeancesDashboard({ filename, patientName });
        } else if (activeTab === 'zonefrontiere') {
          await exportZF({ filename, patientName });
        } else if (activeTab === 'bilan') {
          await exportBilan({ filename, patientName });
        }
    } catch (error) {
      console.error('Erreur lors de l\'export PDF:', error);
      toast({
        title: 'Erreur d\'export',
        description: 'Une erreur est survenue lors de l\'export PDF. Veuillez réessayer.',
        variant: 'destructive',
      });
    }
  };

  return (
    <Button
      onClick={handleExport}
      disabled={isExportingStructured}
      variant={variant}
      size={size}
      className={className}
    >
      {isExportingStructured ? (
        <Loader2 className="mr-2 h-4 w-4 animate-spin" />
      ) : (
        <Download className="mr-2 h-4 w-4" />
      )}
      {isExportingStructured ? 'Export en cours...' : buttonText}
    </Button>
  );
};
